import React from 'react';

import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import NumberFormat from 'react-number-format';

import MlFormField from './MlFormField';

import './form.scss';

const NumberFormatInput = ({
    format, hint, label, error, required, ref, ...inputProps
}) => {
    const hasError = error && error.length > 0;

    return (
        <MlFormField
            label={label}
            name={inputProps.name}
            required={required}
            hint={hint}
            error={error}
        >
            <NumberFormat
                customInput={Form.Control}
                getInputRef={ref}
                format={format}
                isInvalid={hasError}
                {...inputProps}
            />
        </MlFormField>
    );
};

NumberFormatInput.propTypes = {
    required: PropTypes.bool,
    format: PropTypes.string,
    hint: PropTypes.string,
    label: PropTypes.string,
    error: PropTypes.string,
};

export default NumberFormatInput;
